import { TPlatformHandler } from '.';

export const handleParkinsonField: TPlatformHandler = (field, state) => {
  let query: string | undefined = undefined;
  switch (field) {
    case 'currentLEDD': {
      query = '';
      if (state.currentLEDD === 'noCropping') break;

      const qps: string[] = [];

      if (state.currentLEDD.minLEDD || state.currentLEDD.minLEDD === 0) {
        qps.push(`data>=#${state.currentLEDD.minLEDD}`);
      }

      if (state.currentLEDD.maxLEDD) {
        qps.push(`data<=#${state.currentLEDD.maxLEDD}`);
      }

      if (qps.length > 0) query += `§calculatePatientLedd€{${qps.join('&')}}`;
      break;
    }

    case 'dbsTreatment':
      query = '';
      if (state.dbsTreatment !== 'noCropping' && Array.isArray(state.dbsTreatment)) {
        query += 'dbs@hasEnded€{';
        if (state.dbsTreatment.includes('ongoing')) {
          query += '(exists==FALSE|data.0==FALSE|data.length==#0)';
          if (state.dbsTreatment.includes('ended')) query += '|';
        }
        if (state.dbsTreatment.includes('ended')) query += '(exists==TRUE&data.0==TRUE)';
        query += '}';
      }
      break;

    case 'currentHoehnYahr':
      query = '';
      if (state.currentHoehnYahr !== 'noCropping' && state.currentHoehnYahr.length > 0) {
        query += `§getLatestDocumentFieldValue[$updrs_v,$value,$date]€#[${state.currentHoehnYahr
          .map(e => '#' + e.toString())
          .join(',')}])`;
      }
      break;

    case 'thalamotomyOrHIFU':
      query = '';
      if (state.thalamotomyOrHIFU !== 'noCropping' && Array.isArray(state.thalamotomyOrHIFU)) {
        if (state.thalamotomyOrHIFU.includes('thalamotomyDone')) {
          query += '(';
          query += 'thalamotomy@date!=NULL';
          if (state.thalamotomyOrHIFU.includes('hifuDone')) query += ')|';
        }
        if (state.thalamotomyOrHIFU.includes('hifuDone')) {
          query += '(';
          query += 'hifu@date!=NULL';
        }
        query += ')';
      }
      break;

    default:
      return undefined;
  }

  return query;
};
